import { Box, Container } from "@mui/material";
import { useEffect } from "react";
import { Outlet } from "react-router";

import { Loader } from "../../components";
import { submitEvent } from "../../utils/tracking";

import Header from "./components/header";
import RfpStatus from "./components/rfpStatus";

function RFPDetails({
  state,
  dispatch,
  onAnalystChange,
  onDocumentUpload,
  onMarketingPresentationUpload,
  onMarketingPresentationDownload,
  onFileDownload,
  onFileDelete,
  handleDeleteMarketingPresentation,
  refetchRpfDetails,
}) {
  useEffect(() => {
    if (!state.loading && state.data) {
      submitEvent("RFP Details Page Viewed", {
        rfpId: state.data?.rfp?.id,
        clientId: state.data?.clientId,
        clientName: state.data?.rfp?.details?.clientInfo?.name,
        brokerName: state.broker?.name,
      });
    }
  }, [state.data, state.loading, state.broker?.name]);

  if (state.loading) {
    return <Loader />;
  }

  if (!state.data) {
    return null;
  }

  const workbenchContextValue = {
    state,
    dispatch,
    onFileDownload,
    onMarketingPresentationUpload,
    onMarketingPresentationDownload,
    onDeleteMarketingPresentation: handleDeleteMarketingPresentation,
    onDocumentUpload,
    onFileDelete,
    onAnalystChange,
    onUploadCensus: () => {}, // Add implementation if needed
    refetchRpfDetails,
  };

  return (
    <Container>
      <Header state={state} />
      <Box display="flex" flexDirection="column" gap={3}>
        <RfpStatus state={state} />
        <Outlet context={workbenchContextValue} />
      </Box>
    </Container>
  );
}

export default RFPDetails;
